<p-dialog 
  [(visible)]="visible" 
  [modal]="true" 
  [closable]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="whats-new-dialog"
  header="What's New"
  (onHide)="hide()"
>
  <div class="whats-new-content">
    @if (loading) {
      <div class="loading-state">
        <i class="pi pi-spinner pi-spin"></i>
        <p>Loading updates...</p>
      </div>
    }
    
    @if (!loading && whatsNewData.length === 0) {
      <div class="empty-state">
        <i class="pi pi-inbox"></i>
        <p>No updates available</p>
      </div>
    }
    
    @for (item of whatsNewData; track item.id) {
      <div class="version-section">
        <div class="version-header">
          <h3 class="version-number">Version {{ item.version }}</h3>
          <span class="version-date">{{ formatDate(item.releaseDate) }}</span>
        </div>

        @if (item.features && item.features.length > 0) {
          <div class="change-category">
            <h4 class="category-title">
              <i class="pi pi-star-fill"></i>
              New Features
            </h4>
            <ul class="change-list">
              @for (feature of item.features; track $index) {
                <li>{{ feature }}</li>
              }
            </ul>
          </div>
        }

        @if (item.improvements && item.improvements.length > 0) {
          <div class="change-category">
            <h4 class="category-title">
              <i class="pi pi-arrow-up"></i>
              Improvements
            </h4>
            <ul class="change-list">
              @for (improvement of item.improvements; track $index) {
                <li>{{ improvement }}</li>
              }
            </ul>
          </div>
        }

        @if (item.bugFixes && item.bugFixes.length > 0) {
          <div class="change-category">
            <h4 class="category-title">
              <i class="pi pi-wrench"></i>
              Bug Fixes
            </h4>
            <ul class="change-list">
              @for (bugFix of item.bugFixes; track $index) {
                <li>{{ bugFix }}</li>
              }
            </ul>
          </div>
        }
      </div>
    }
  </div>

  <ng-template pTemplate="footer">
    <p-button 
      label="Close" 
      icon="pi pi-times" 
      (onClick)="hide()" 
      styleClass="p-button-text"
    ></p-button>
  </ng-template>
</p-dialog>

